import { strings } from '@purple-start-registration/common/localization';

export default () => ({
  familyName: {
    required: {
      value: true,
      message: strings.validationRequired,
    },
  },
  givenName: {
    required: {
      value: true,
      message: strings.validationRequired,
    },
  },
  dateOfBirth: {
    required: {
      value: true,
      message: strings.validationRequired,
    },
  },
  emailAddress: {
    pattern: {
      value:
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
      message: strings.validationEmail,
    },
    required: {
      value: true,
      message: strings.validationRequired,
    },
  },
  street: {
    required: {
      value: true,
      message: strings.validationRequired,
    },
  },
  city: {
    required: {
      value: true,
      message: strings.validationRequired,
    },
  },
  phone1: {
    required: {
      value: true,
      message: strings.validationRequired,
    },
  },
  acceptTerms: {
    required: {
      value: true,
      message: strings.acceptTermsRequired,
    },
  },
  phone2: {},
  club: {},
  registerNewsletter: {},
});
